//desktop
import MessageBoxLayer from './components/@common/Layer/MessageBoxLayer';
import EmbedLayer from './components/@common/Layer/EmbedLayer';
import EmbedVideo from './components/@common/Layer/EmbedLayer/EmbedVideo';
import DesktopPdfPreview from './components/PdfPreview/Desktop';
import DesktopPageWrapper from './components/@common/PageWrapper/Desktop';
import DesktopPage from './components/@common/Viewer/Desktop';
import DesktopViewerLayer from './components/@common/Layer/DefaultViewerLayer/Desktop';
// mobile
import MobilePdfPreview from './components/PdfPreview/Mobile';
// else
import Loading from './components/@common/Loading';
import PdfPageImage from './components/@common/PdfPageImage';
import PdfThumbImage from './components/@common/PdfThumbImage';
// compounded components
import Enter from './components/PdfViewer/Enter';
import Redirect from './components/PdfViewer/Redirect';
import BulkRedirectViewer from './components/BulkViewer';
import BulkDesktopPdfPreview from './components/BulkPdfPreview/Desktop';
import BulkMobilePdfPreview from './components/BulkPdfPreview/Mobile';
// v2 preview
import V2BulkPreview from './components/v2/V2BulkPreview';
import V2OneToOnePreview from './components/v2/V2OneToOnePreview';
//context
import {
  ViewerRouteProvider,
  useViewerRoute,
  type ViewerRouteValue,
  type ViewerRouteOverride,
} from './contexts/ViewerRoute';
//store
import { zoomLevelAtom } from './store/index.atom';
//utils
import {
  normalizeEmbedOptions,
  getEmbedIframeSrc,
  parseVideoUrl,
} from './utils/embed';
import { getViewerHistoryStorageKey } from './utils/viewerHistoryStorage';
//type
import {
  PdfViewerRedirect,
  EmbedProvider,
  EmbedOptions,
  EmbedType,
  EmbedItemType,
} from './components/PdfViewer/index.types';
import {
  ImageSourcesDto,
  ImageSourcesThumb,
  ImageSourcesViewer,
} from './types/imageSources';

export {
  // desktop
  DesktopPdfPreview,
  DesktopPage,
  DesktopPageWrapper,
  DesktopViewerLayer,
  MessageBoxLayer,
  EmbedLayer,
  EmbedVideo,
  // mobile
  MobilePdfPreview,
  // else
  Loading,
  PdfPageImage,
  PdfThumbImage,
  // compounded components
  Enter,
  Redirect,
  BulkRedirectViewer,
  BulkDesktopPdfPreview,
  BulkMobilePdfPreview,
  // v2 preview
  V2BulkPreview,
  V2OneToOnePreview,
  // context
  ViewerRouteProvider,
  useViewerRoute,
  // store
  zoomLevelAtom,
  // utils
  normalizeEmbedOptions,
  getEmbedIframeSrc,
  parseVideoUrl,
  getViewerHistoryStorageKey,
  // type
  type PdfViewerRedirect,
  type EmbedProvider,
  type EmbedOptions,
  type EmbedType,
  type EmbedItemType,
  type ImageSourcesDto,
  type ImageSourcesThumb,
  type ImageSourcesViewer,
  type ViewerRouteValue,
  type ViewerRouteOverride,
};
